export const isProduction = process.env.NODE_ENV === "production";
export const version = process.env.VERSION ?? "Unbekannt";

export const pollDocumentTimeoutMs = 1000;
export const pollDocumentRetries = 60;
export const completeTaskReconciliationAttempts = 10;
export const requestRetryAttempts = 2;
export const requestRetryDelayMs = 1000;

export const pollExportCsvResultTimeoutMS = 1000;
